import { PDFRelatorioBase } from "components/PDF";
import useExportarConsumoPdfColumns from "../../hooks/useExportarConsumoPdfColumns";
import { mapTipoConsumo } from "../ListarConsumo";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import moment from "moment";
import { capitalizeFirstLetter } from "infra/helpers/capitalizeFirstLetter";
import {
  ConsumoPdfQueryParams,
  ConsumoDashboardDto,
  PdfConsumoUnidadeResponse,
  ConsumoDto,
} from "core/features/consumo/typings";

function PDFExportarConsumo(
  props: PdfConsumoUnidadeResponse & {
    consumo: ConsumoDto;
    filtro: ConsumoPdfQueryParams;
    dashboard?: ConsumoDashboardDto;
    unidadeMedida?: string;
  }
) {
  const columns = useExportarConsumoPdfColumns(props.consumo, props.filtro);

  const mesConsumo = capitalizeFirstLetter(
    moment(props.filtro.mes, "YYYY-MM").format("MMMM [de] YYYY")
  );

  return (
    <PDFRelatorioBase
      title={`Consumo de ${mapTipoConsumo[props.filtro.tipoConsumoId!]}`}
      relatorioData={{
        ...props,
        periodo: mesConsumo,
      }}
      columns={columns}
      pdfHeaderProps={{
        cards: [
          {
            title: "Consumo",
            value: `${props.dashboard?.totalConsumo ?? 0} ${
              props.unidadeMedida
            }`,
            alignItems: "flex-end",
          },
          {
            title: `Total a cobrar`,
            value: `R$ ${formatCurrency(
              props.dashboard?.valorCobradoTotal ?? 0
            )}`,
            alignItems: "flex-end",
          },
        ],
      }}
    />
  );
}

export default PDFExportarConsumo;
